import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { DebounceInput } from 'react-debounce-input'

import { httpOk, GET } from 'helpers/api'
import { formatDate, regexPhoneNumber, returnSign } from 'helpers/helpers'

function Index({ modalSearchClient, setClients, toggleModalClients, handleSelectClient }) {
	// setClients не обязателен — список нужен не всем страницам
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchClients(value = "") {
		var urlParams = ""
		if (value)
			urlParams += returnSign(urlParams) + 'search=' + value

		const response = await GET(`/search-clients${urlParams}`, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			if (typeof setClients === 'function') setClients(response.data)
		}
	}

	useEffect(() => {
		if (modalSearchClient) searchClients()
	}, [modalSearchClient]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal show={modalSearchClient} animation={false} centered
				size="lg" onHide={() => toggleModalClients()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('clients')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<DebounceInput
						type="text"
						className="form-control mb-2"
						placeholder={t('search') + '...'}
						minLength={2}
						debounceTimeout={1000}
						onChange={(e) => searchClients(e.target.value)}
						onKeyUp={(e) => {
							if (e.keyCode === 13) {
								searchClients(e.target.value)
							}
						}}
					/>

					<div className="table-responsive" style={{ 'height': '300px', 'overflow': 'auto' }}>
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '140px' }}>{t('phone')}</th>
									<th style={{ 'width': '100%' }}>{t('name')}</th>
									<th style={{ 'minWidth': '120px' }}>{t('card_number')}</th>
									<th style={{ 'minWidth': '140px' }} className="text-center">{t('registered')}</th>
									<th style={{ 'minWidth': '140px' }} className="text-center">{t('last_cheque')}</th>
									<th style={{ 'minWidth': '70px' }} className="text-end">{t('cheques')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}
										onClick={() => handleSelectClient(item)}>
										<td className="text-center" title={item.id}>{index + 1}</td>
										<td>{regexPhoneNumber(item.phone1)}</td>
										<td>{item.first_name}</td>
										<td className="td-ellipsis" title={item.card_numbers}>{item.card_numbers}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td className="text-center">{formatDate(item.last_cheque_date)}</td>
										<td className="text-end">{item.count_cheques}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index